import React from 'react';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { useIntl } from '@atlassian/jira-intl';
import {
	ReadViewContainer,
	RoleContainer,
	RoleDisplayName,
	RoleList,
	PlaceholderSpacer,
} from '../../common/ui/styled.tsx';
import { messages } from './messages.tsx';

export type Group = {
	name: string;
};

const GroupReadView = ({ displayName }: { displayName: string }) => (
	<RoleContainer key={displayName}>
		<PeopleGroupIcon label="" />
		<RoleDisplayName>{displayName}</RoleDisplayName>
	</RoleContainer>
);

export const GroupsReadView = ({
	groups,
	showPlaceholderIfEmpty = true,
}: {
	groups: Group[];
	showPlaceholderIfEmpty?: boolean;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	if (groups.length === 0) {
		return (
			<ReadViewContainer isPlaceholder>
				<PlaceholderSpacer>
					{showPlaceholderIfEmpty ? formatMessage(messages.placeholder) : null}
				</PlaceholderSpacer>
			</ReadViewContainer>
		);
	}
	return (
		<ReadViewContainer>
			<RoleList>
				{groups.map(({ name }) => (
					<GroupReadView key={name} displayName={name} />
				))}
			</RoleList>
		</ReadViewContainer>
	);
};
